<template>
<div class="component">

    <div class="eventList">
        <transition-group name="eventListTransition" tag="">

            <div class="eventItem columns is-mobile is-multiline" v-if="participateEvents.length >0" v-for="event in participateEvents" :key="event.id">

                <div class="is-1 column eventListLeft" @click="onEventTitleClick(event.id)">
                    <div class="eventListDate">{{formatDate(event.date)[0]}}<br>{{formatDate(event.date)[1]}}</div>
                </div>

                <div class="column is-2 eventListMiddle" @click="onEventTitleClick(event.id)">
                    <div class="eventListDot" :class="{'eventListDotPast':!event.isOpen}"></div>
                    <div class="eventListLine" :class="{'activeEventListLine':openEvent == event.id}"></div>
                </div>

                <div class=" column is-8 eventListRight">

                    <div class="columns is-mobule is-multiline">
                        <div class="column is-8">
                            <div @click="onEventTitleClick(event.id)" class="eventTitle">{{event.title}}</div>
                            <transition name="eventPartTransition">

                                <div v-if="openEvent == event.id">
                                    <div @click="onEventTitleClick(event.id)">
                                        <div>{{event.description}}</div><br>
                                        <div v-if="event.room==null">{{$t('enaq_translation_events_place')}}: {{event.place}}</div>
                                        <div v-else>{{$t('enaq_translation_events_place')}}: {{event.room.name}}</div><br>
                                    </div>
                                    <div v-if="event.isOpen" class="has-text-centered" @click="leave(event)">{{$t('enaq_translation_events_leave')}} <i class="fas fa-sign-out-alt"></i></div>

                                </div>
                            </transition>
                        </div>
                        <div class="column is-4 locationNameContainer" @click="onEventTitleClick(event.id)">
                            <div class="locationName" v-if="event.room==null">{{event.place}}</div>
                            <div class="locationName" v-else>{{event.room.name}}</div>
                        </div>
                    </div>

                </div>

            </div>
        </transition-group>

    </div>

    <br>
    <header class="modal-card-head" @click="openTabByName('own')">
        <p class="modal-card-title">{{$t('enaq_translation_events_own')}}</p>
        <i class="fas fa-chevron-down"></i>
    </header>

    <transition name="eventPartTransition">
        <div class="ownEvents" v-if="openTab=='own'">
            <table class="table is-fullwidth">
                <thead>
                    <tr>
                        <th class="has-text-centered" width="60%">{{$t('enaq_translation_events_title')}}</th>
                        <th class="has-text-centered" width="10%">{{$t('enaq_translation_events_member')}}</th>
                        <th class="has-text-centered" width="15%">{{$t('enaq_translation_events_update')}}</th>
                        <th class="has-text-centered" width="15%">{{$t('enaq_translation_events_delete')}}</th>

                    </tr>
                </thead>

                <tbody>
                    <tr class="messageRow" v-for="event in ownEvents" v-if="event.isOpen">
                        <td class="has-text-centered">{{event.title}}</td>

                        <td class="has-text-centered" @click="showMembers(event)"><i class="fas fa-users"></i></td>
                        <td class="has-text-centered" @click="selectEditEvent(event)"><i class="fas fa-edit"></i></td>
                        <td class="has-text-centered" @click="deleteEvent(event)"><i class="fas fa-trash"></i></td>

                    </tr>

                    <tr class="messageRow" v-for="event in ownEvents" v-if="!event.isOpen">
                        <td class="has-text-centered">{{event.title}}</td>

                        <td class="has-text-centered" @click="showMembers(event)"><i class="fas fa-users"></i></td>
                        <td class="has-text-centered" colspan="2">{{$t('enaq_translation_events_closed')}}</td>

                    </tr>
                </tbody>
            </table>
        </div>
    </transition>
    <div v-if="openModal">
        <editEvent :event="selectedEventToEdit" @closeModal="closeEventModal"></editEvent>
    </div>

    <div class="memberModal" v-if="selectedMemberEvent != ''">
        <div class="modal is-active">
            <div class="modal-background" @click="selectedMemberEvent=''"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{$t('enaq_translation_events_member')}}</p>
                    <button class="delete" aria-label="close" @click="selectedMemberEvent=''"></button>
                </header>
                <section class="modal-card-body" v-if="selectedMemberEvent.isOpen">
                    <div class="" v-if="selectedMemberEvent.members==null||selectedMemberEvent.members.length==0||selectedMemberEvent.members==undefined">{{$t('enaq_translation_events_member_none')}}</div>
                    <div class="columns is-mobile is-multiline" v-for="member in selectedMemberEvent.members" v-if="member.removed==undefined||member.removed!=true">
                        <div class="column is-8">{{member.user.firstname}} {{member.user.name}}</div>

                        <div v-if="selectedMemberEvent.needsManualParticipateConfirmation  ">
                            <span class="button is-succeess" v-if="!member.accepted" @click="acceptMember(member)">{{$t('enaq_translation_events_member_accept')}}</span>
                            <span class="button is-danger" v-else @click="removeMember(member)">{{$t('enaq_translation_events_member_remove')}}</span>

                        </div>
                        <div v-else><span class="button is-danger" @click="removeMember(member)">{{$t('enaq_translation_events_member_remove')}}</span></div>
                    </div>
                </section>
                <section class="modal-card-body" v-else>
                    <div class="" v-if="selectedMemberEvent.members==null||selectedMemberEvent.members.length==0||selectedMemberEvent.members==undefined">{{$t('enaq_translation_events_member_none')}}</div>
                    <div class="columns is-mobile is-multiline" v-for="member in selectedMemberEvent.members">
                        <div class="column is-12">{{member.user.firstname}} {{member.user.name}}</div>
                    </div>
                </section>
                <footer class="modal-card-foot has-text-centered">
                    <button class="button" @click="selectedMemberEvent=''">{{$t('enaq_translation_events_new_cancel')}}</button>
                </footer>
            </div>
        </div>
    </div>
    <br>
    <div class="has-text-right"><span class="button is-info is-large" @click="openModal=true">{{$t('enaq_translation_events_new_button')}}</span></div><br>

</div>
</template>

<script>
import slidebutton from '@/components/helper/slidebutton.vue'
import infoModal from '@/components/infoModal.vue';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import editEvent from '@/components/editEvent.vue';

export default {
    name: 'Events',
    components: {
        slidebutton,
        infoModal,
        Datepicker,
        editEvent,
    },
    props: ["eventtoedit"],
    mounted: function () {
        this.getOwnEvents();
        this.getParticipateEvents();
        if (this.eventtoedit) {
            this.selectedEventToEdit = this.eventtoedit;
            this.openModal = true;
        }

    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            openEvent: null,
            selectedEvent: null,
            ownEvents: [],
            participateEvents: [],
            selectedEventToEdit: "",
            openModal: false,
            selectedMemberEvent: "",
            openTab: ""

        }
    },
    methods: {
        openTabByName(name) {
            if (this.openTab == name) {
                this.openTab = ''
            } else {
                this.openTab = name;
            }
        },
        getOwnEvents() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            this.$axios.get(this.$backendURL + "/events/own", {
                headers: headerData
            }).then(function (result) {
                this.ownEvents = result.data.events
            }.bind(this))
        },
        getParticipateEvents() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            this.$axios.get(this.$backendURL + "/events/participated", {
                headers: headerData
            }).then(function (result) {

                result.data.participated = result.data.participated.sort(function (a, b) {
                    return b.date > a.date ? 1 : -1
                })
                /*
                                for (var i = 0; i < result.data.participated.length; i++) {
                                    var eventItem = result.data.participated[i]
                                    setTimeout(function () {
                                        this.participateEvents.push(eventItem)
                                    }.bind(this), 100 * i);
                                }
                */

                this.participateEvents = result.data.participated
            }.bind(this))
        },
        selectEditEvent(event) {
            this.selectedEventToEdit = event;
            this.openModal = true;
        },
        leave(event) {

            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            let postData = {}
            this.$axios.post(this.$backendURL + "/events/" + event.id + "/leave", postData, {
                headers: headerData
            }).then(function (result) {
                this.getParticipateEvents();
            }.bind(this))

        },
        deleteEvent(event) {

            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            let postData = {}
            this.$axios.post(this.$backendURL + "/events/" + event.id + "/delete", postData, {
                headers: headerData
            }).then(function (result) {
                this.getOwnEvents();
            }.bind(this))
        },

        removeMember(member) {

            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            let postData = {
                'member': member.user_id
            }
            this.$axios.post(this.$backendURL + "/events/" + member.event_id + "/remove", postData, {
                headers: headerData
            }).then(function (result) {
                member.removed = true;
                this.getOwnEvents();
            }.bind(this))
        },
        acceptMember(member) {

            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            let postData = {
                'member': member.user_id
            }
            this.$axios.post(this.$backendURL + "/events/" + member.event_id + "/accept", postData, {
                headers: headerData
            }).then(function (result) {
                this.getOwnEvents();
                member.accepted = 1
            }.bind(this))
        },
        showMembers(event) {
            this.selectedMemberEvent = event
        },
        closeEventModal() {
            this.openModal = false;
            this.selectedEventToEdit = '';
            this.getOwnEvents();
        },
        onEventTitleClick(eventid) {
            if (this.openEvent == eventid) {
                this.openEvent = -1;
            } else {
                this.openEvent = eventid
            }
        },
        formatDate(date) {
            var formattedDate = new Date(date);
            var dateValues = []
            var options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',

            };
            // 
            dateValues.push(formattedDate.toLocaleDateString('de-DE', options))
            var optionsH = {
                hour: 'numeric',
            };
            dateValues.push(formattedDate.getHours() + " " + this.$t('enaq_translation_events_hour'))

            return dateValues;
        }
    },
    computed: {},
}
</script>

<style scoped>
.viewTitle {
    margin-top: 15px;
    font-weight: bolder;
    font-size: 3em
}

.createEvent {
    margin-top: 25px;
}

.textareaPartial {
    min-width: 0px;
    margin-bottom: 0.5em
}

.roomSelect {
    text-align: left;
}

.sendButton {
    margin-bottom: 20px;
}

.eventPartTransition-enter-active {
    transition: all 0.7s;

    overflow: hidden;
    max-height: 100vh;
}

.eventPartTransition-leave-active {
    transition: all 0.3s;
    overflow: hidden;
    max-height: 100vh;
}

.eventPartTransition-enter,
.eventPartTransition-leave-to {
    opacity: 0;
    max-height: 0px;

}

.eventList {
    padding: 10px;
    border-radius: 4px;

}

.eventList .eventItem {
    margin-bottom: 10px !important;
}

.eventListLine {
    display: block;
    height: calc(100%);
    border-left: 10px solid #f5f5f5;
    margin-top: 2%;
    margin-left: -5px;
    max-width: 10px;
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
    z-index: 3;
    position: absolute;

}

.activeEventListLine {
    border-left: 10px solid #F0AD12;
    border-radius: 0px;
    z-index: 3;

}

.eventListDot {
    border: 3px solid #F0AD12;
    height: 14px;
    width: 14px;
    border-radius: 40px;
    margin-left: -7px;
    z-index: 30;
    position: absolute;
    background: white;

}

.eventListDotPast {
    border: 3px solid #a5a5a5;
    z-index: 30;

}

.eventListLeft {
    font-size: 0.8em;

    display: inline-block;

}

.eventListDate {
    font-size: 1em;
    background: #f5f5f5;
    padding: 5% 10%;
    display: inline-block;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;

}

.eventListMiddle {
    padding-bottom: 0;
    position: relative;

}

.eventListRight .eventTitle {
    font-size: 1.8em;
    font-weight: bolder;
    padding-bottom: .3rem;
    margin-top: .3rem;

}

.eventListRight {
    padding-bottom: 10px;
    border-bottom: 3px solid #f5f5f5;
    cursor: pointer;

}

.eventListTransition-enter-active,
.eventListTransition-leave-active {
    transition: all .5s;
}

.eventListTransition-enter {
    margin-left: 500px;
}

.eventListTransition-enter-to {
    margin-left: 1px;

}

.locationName {
    display: inline-block;
    width: 80%;
    padding: 5px;
    border-radius: 10px;
    background: #f5f5f5;
    color: #F0AD12;
    font-weight: bolder;
    margin-top: .6rem;
    overflow: hidden;

}
</style>
